var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { LitElement } from 'lit';
import { html } from 'lit-html';
import { property, query, state } from 'lit/decorators.js';
import { cloneDeep, uniqueId } from 'lodash-es';
import '../../../button/default/sds-button.lit';
import { currentDateKey } from '../../../datepicker/date/date-picker-calculations';
import '../../../datepicker/shared/calendar/sds-calendar.lit';
import { tripletLessOrEqual } from '../../../datepicker/shared/comparators';
import { dateHoverStateMapper, dateRangeMapper, monthRangeMapper, yearRangeMapper, } from '../../../datepicker/shared/mapper-utils';
import '../../../input/time-picker/sds-time-picker-input.lit';
import '../../../time/components/shared/sds-time-picker-content.lit';
import { getElementById } from '../../../time/utils/time.util';
import { sdsCustomElement } from '../../../utilities/custom-components';
import { appendStylesToTheStyleRoot } from '../../../utilities/dom';
import { hideMenuProvider } from '../../../utilities/picker.tools';
import { translate } from '../../../utilities/translate';
import { dateTimeToKey, displayDateTime, getCurrentLocaleDate, isValid, keyToDateTime, localeDateToLocaleMonth, } from '../../utils/date-time.util';
import styles from './sds-date-time-range.lit.scss';
/**
 * `sds-date-time-range` is a web component that allows users to select a range of dates and times.
 *
 * ### Features:
 * - Supports selecting both **start** and **end** dates with precise times.
 * - Allows customization with placeholder texts, locales, and time formats.
 * - Emits events on value changes for seamless integration with other components or business logic.
 */
let SdsDateTimeRange = (() => {
    var _SdsDateTimeRange_hint_accessor_storage, _SdsDateTimeRange_disabled_accessor_storage, _SdsDateTimeRange_invalid_accessor_storage, _SdsDateTimeRange_errorMessage_accessor_storage, _SdsDateTimeRange_placeholder_accessor_storage, _SdsDateTimeRange_locale_accessor_storage, _SdsDateTimeRange_format_accessor_storage, _SdsDateTimeRange__inputDate_accessor_storage, _SdsDateTimeRange__contextMenu_accessor_storage, _SdsDateTimeRange__tempStart_accessor_storage, _SdsDateTimeRange__tempEnd_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-date-time-range')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _instanceExtraInitializers = [];
    let _hint_decorators;
    let _hint_initializers = [];
    let _hint_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _invalid_decorators;
    let _invalid_initializers = [];
    let _invalid_extraInitializers = [];
    let _errorMessage_decorators;
    let _errorMessage_initializers = [];
    let _errorMessage_extraInitializers = [];
    let _placeholder_decorators;
    let _placeholder_initializers = [];
    let _placeholder_extraInitializers = [];
    let _locale_decorators;
    let _locale_initializers = [];
    let _locale_extraInitializers = [];
    let _format_decorators;
    let _format_initializers = [];
    let _format_extraInitializers = [];
    let __inputDate_decorators;
    let __inputDate_initializers = [];
    let __inputDate_extraInitializers = [];
    let __contextMenu_decorators;
    let __contextMenu_initializers = [];
    let __contextMenu_extraInitializers = [];
    let __tempStart_decorators;
    let __tempStart_initializers = [];
    let __tempStart_extraInitializers = [];
    let __tempEnd_decorators;
    let __tempEnd_initializers = [];
    let __tempEnd_extraInitializers = [];
    let _set_start_decorators;
    let _set_end_decorators;
    var SdsDateTimeRange = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsDateTimeRange_hint_accessor_storage.set(this, (__runInitializers(this, _instanceExtraInitializers), __runInitializers(this, _hint_initializers, '')));
            _SdsDateTimeRange_disabled_accessor_storage.set(this, (__runInitializers(this, _hint_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            _SdsDateTimeRange_invalid_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _invalid_initializers, false)));
            _SdsDateTimeRange_errorMessage_accessor_storage.set(this, (__runInitializers(this, _invalid_extraInitializers), __runInitializers(this, _errorMessage_initializers, '')));
            _SdsDateTimeRange_placeholder_accessor_storage.set(this, (__runInitializers(this, _errorMessage_extraInitializers), __runInitializers(this, _placeholder_initializers, 'sds.date_time_range.placeholder')));
            _SdsDateTimeRange_locale_accessor_storage.set(this, (__runInitializers(this, _placeholder_extraInitializers), __runInitializers(this, _locale_initializers, navigator.language)));
            _SdsDateTimeRange_format_accessor_storage.set(this, (__runInitializers(this, _locale_extraInitializers), __runInitializers(this, _format_initializers, 24)));
            _SdsDateTimeRange__inputDate_accessor_storage.set(this, (__runInitializers(this, _format_extraInitializers), __runInitializers(this, __inputDate_initializers, void 0)));
            _SdsDateTimeRange__contextMenu_accessor_storage.set(this, (__runInitializers(this, __inputDate_extraInitializers), __runInitializers(this, __contextMenu_initializers, void 0)));
            _SdsDateTimeRange__tempStart_accessor_storage.set(this, (__runInitializers(this, __contextMenu_extraInitializers), __runInitializers(this, __tempStart_initializers, undefined)));
            _SdsDateTimeRange__tempEnd_accessor_storage.set(this, (__runInitializers(this, __tempStart_extraInitializers), __runInitializers(this, __tempEnd_initializers, undefined)));
            this._inputId = (__runInitializers(this, __tempEnd_extraInitializers), uniqueId('sds-date-time-range'));
            this._calendarId = uniqueId('sds-calendar');
            this._sdsTimePickerContentStart = uniqueId('sds-time-picker-content');
            this._sdsTimePickerContentEnd = uniqueId('sds-time-picker-content');
            this._currentDay = currentDateKey();
            this.hideMenu = (event) => {
                var _a;
                hideMenuProvider(this)(event);
                if (!((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened)) {
                    this._tempStart = undefined;
                    this._tempEnd = undefined;
                }
            };
            this.clear = () => {
                this.start = undefined;
                this.end = undefined;
                this.dispatch(null);
                this.hideMenu();
            };
            this.handleOK = () => {
                var _a, _b;
                if (((_a = this._tempStart) === null || _a === void 0 ? void 0 : _a.date) && ((_b = this._tempEnd) === null || _b === void 0 ? void 0 : _b.date)) {
                    this.start = dateTimeToKey(this._tempStart);
                    this.end = dateTimeToKey(this._tempEnd);
                    this.dispatch({ start: this.start, end: this.end });
                    this.updateInput();
                }
                this.hideMenu();
            };
            this.handleTimeChangeStart = (event) => {
                if (this._tempStart) {
                    this._tempStart.time = event.detail.value;
                }
            };
            this.handleTimeChangeEnd = (event) => {
                if (this._tempEnd) {
                    this._tempEnd.time = event.detail.value;
                }
            };
            this.handleDatePicked = (event) => {
                if (!this._tempStart || !this._tempEnd) {
                    return;
                }
                if (this._tempEnd.date || !this._tempStart.date) {
                    this._tempStart.date = event.detail.date;
                    this.selectRange(event.detail.date, undefined);
                    this._tempEnd.date = undefined;
                }
                else if (!tripletLessOrEqual(this._tempStart.date, event.detail.date)) {
                    this._tempEnd.date = [...this._tempStart.date];
                    this._tempStart.date = event.detail.date;
                    this.selectRange(event.detail.date, this._tempEnd.date);
                }
                else {
                    this._tempEnd.date = event.detail.date;
                    this.selectRange(this._tempStart.date, event.detail.date);
                }
            };
            this.showContextMenu = () => {
                var _a;
                if ((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened) {
                    return;
                }
                this.prepareContextMenu();
                setTimeout(() => {
                    var _a;
                    this._inputDate.focused = true;
                    const trigger = this._inputDate.getInput();
                    (_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.show(trigger);
                });
                document.addEventListener('mousedown', this.hideMenu);
            };
            this.handleHover = (event) => {
                var _a;
                if (event.detail &&
                    event.detail.hoveredItem &&
                    this._dateTimeStart.date &&
                    !this._dateTimeEnd.date) {
                    (_a = this.sdsCalendar) === null || _a === void 0 ? void 0 : _a.setDateStateMapper(dateHoverStateMapper(this._dateTimeStart.date, event.detail.hoveredItem));
                }
            };
            this.mouseOutHandler = () => {
                var _a;
                if (this._dateTimeStart.date && !this._dateTimeEnd.date) {
                    (_a = this.sdsCalendar) === null || _a === void 0 ? void 0 : _a.setDateStateMapper(dateRangeMapper(this._dateTimeStart.date, undefined));
                }
            };
        }
        /**
         * Hint for this date time range.
         * @attr
         */
        get hint() { return __classPrivateFieldGet(this, _SdsDateTimeRange_hint_accessor_storage, "f"); }
        set hint(value) { __classPrivateFieldSet(this, _SdsDateTimeRange_hint_accessor_storage, value, "f"); }
        /**
         * True if this date time range is disabled.
         * @attr
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsDateTimeRange_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsDateTimeRange_disabled_accessor_storage, value, "f"); }
        /**
         * True if this date time range is invalid.
         * @attr
         */
        get invalid() { return __classPrivateFieldGet(this, _SdsDateTimeRange_invalid_accessor_storage, "f"); }
        set invalid(value) { __classPrivateFieldSet(this, _SdsDateTimeRange_invalid_accessor_storage, value, "f"); }
        /**
         * The error message of this date time range, in case there is a validation error.
         * @attr
         */
        get errorMessage() { return __classPrivateFieldGet(this, _SdsDateTimeRange_errorMessage_accessor_storage, "f"); }
        set errorMessage(value) { __classPrivateFieldSet(this, _SdsDateTimeRange_errorMessage_accessor_storage, value, "f"); }
        /**
         * A placeholder text that appears inside the picker input when no value is selected.
         * It provides a hint to the user about the expected input format or purpose of the picker.
         *
         * @attr {string} placeholder - Placeholder text displayed in the input field.
         */
        get placeholder() { return __classPrivateFieldGet(this, _SdsDateTimeRange_placeholder_accessor_storage, "f"); }
        set placeholder(value) { __classPrivateFieldSet(this, _SdsDateTimeRange_placeholder_accessor_storage, value, "f"); }
        /**
         * The locale used for formatting dates and times within the picker.
         * This value determines the display format based on the user’s regional settings,
         * such as `'en-US'` or `'fr-FR'`.
         *
         * Defaults to the browser's current language (`navigator.language`).
         *
         * @attr {string} locale - Locale for date and time formatting.
         */
        get locale() { return __classPrivateFieldGet(this, _SdsDateTimeRange_locale_accessor_storage, "f"); }
        set locale(value) { __classPrivateFieldSet(this, _SdsDateTimeRange_locale_accessor_storage, value, "f"); }
        /**
         * Specifies the time format used by the picker: either 12-hour (AM/PM) or 24-hour format.
         * This helps adapt the picker to different user preferences or regional standards.
         *
         * Defaults to `24`.
         *
         * @attr {number} format - Time format used by the picker (`12` or `24`).
         */
        get format() { return __classPrivateFieldGet(this, _SdsDateTimeRange_format_accessor_storage, "f"); }
        set format(value) { __classPrivateFieldSet(this, _SdsDateTimeRange_format_accessor_storage, value, "f"); }
        get _inputDate() { return __classPrivateFieldGet(this, _SdsDateTimeRange__inputDate_accessor_storage, "f"); }
        set _inputDate(value) { __classPrivateFieldSet(this, _SdsDateTimeRange__inputDate_accessor_storage, value, "f"); }
        get _contextMenu() { return __classPrivateFieldGet(this, _SdsDateTimeRange__contextMenu_accessor_storage, "f"); }
        set _contextMenu(value) { __classPrivateFieldSet(this, _SdsDateTimeRange__contextMenu_accessor_storage, value, "f"); }
        get _tempStart() { return __classPrivateFieldGet(this, _SdsDateTimeRange__tempStart_accessor_storage, "f"); }
        set _tempStart(value) { __classPrivateFieldSet(this, _SdsDateTimeRange__tempStart_accessor_storage, value, "f"); }
        get _tempEnd() { return __classPrivateFieldGet(this, _SdsDateTimeRange__tempEnd_accessor_storage, "f"); }
        set _tempEnd(value) { __classPrivateFieldSet(this, _SdsDateTimeRange__tempEnd_accessor_storage, value, "f"); }
        get start() {
            return dateTimeToKey(this._dateTimeStart);
        }
        /** {year}/{month}/{day}/{hour}/{minute} format */
        set start(value) {
            this.requestUpdate('start', this.start);
            this._dateTimeStart = keyToDateTime(value);
        }
        get end() {
            return dateTimeToKey(this._dateTimeEnd);
        }
        /** {year}/{month}/{day}/{hour}/{minute} format */
        set end(value) {
            this.requestUpdate('end', this.end);
            this._dateTimeEnd = keyToDateTime(value);
        }
        get sdsCalendar() {
            var _a, _b;
            if (!this._sdsCalendar) {
                this._sdsCalendar = ((_b = (_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.queryMenuChild('sds-calendar')) !== null && _b !== void 0 ? _b : getElementById(this._calendarId));
            }
            return this._sdsCalendar;
        }
        connectedCallback() {
            super.connectedCallback();
            appendStylesToTheStyleRoot(this, 'sds-date-time-range', SdsDateTimeRange.styles.cssText);
        }
        render() {
            return html `
            <sds-input-date
                id="${this._inputId}"
                placeholder="${translate(this.placeholder)}"
                value="${this.getTimePickerValue()}"
                readonly="${true}"
                ?disabled="${this.disabled}"
                hint="${this.hint}"
                error-message="${this.errorMessage}"
                ?invalid="${this.invalid}"
                @click="${this.showContextMenu}"
                @sds.input-date.cleared="${this.clear}"
            ></sds-input-date>
            <sds-context-menu maxHeight="468px">
                <div class="sds-date-time-range">
                    <sds-calendar
                        id="${this._calendarId}"
                        currentDay="${this._currentDay}"
                        tabindex="0"
                        locale="${this.locale}"
                        @sds.calendar.select="${this.handleDatePicked}"
                        @mouseout="${this.mouseOutHandler}"
                        @sds.calendar.hover="${this.handleHover}"
                    >
                    </sds-calendar>
                    ${this.format === 12 ? this.timeFormat12() : this.timeFormat24()}
                    <div class="sds-date-time-range__footer">
                        <sds-button
                            label="${translate('sds.button.ok')}"
                            type="primary"
                            size="sm"
                            @click="${this.handleOK}"
                        ></sds-button>
                    </div>
                </div>
            </sds-context-menu>
        `;
        }
        disconnectedCallback() {
            document.removeEventListener('mousedown', this.hideMenu);
            this.hideMenu();
            super.disconnectedCallback();
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        willUpdate(_changedProperties) {
            super.willUpdate(_changedProperties);
            if (_changedProperties.has('start') || _changedProperties.has('end')) {
                this.hideMenu();
            }
        }
        updated(_changedProperties) {
            super.updated(_changedProperties);
            if (!isValid(this.start, this.end)) {
                this._dateTimeStart = keyToDateTime(undefined);
                this._dateTimeEnd = keyToDateTime(undefined);
            }
        }
        prepareContextMenu() {
            this._tempStart = cloneDeep(this._dateTimeStart);
            this._tempEnd = cloneDeep(this._dateTimeEnd);
            this.updatePageIndex();
            this.selectRange(this._dateTimeStart.date, this._dateTimeEnd.date);
        }
        updatePageIndex() {
            var _a;
            const date = this._dateTimeStart.date || getCurrentLocaleDate();
            (_a = this.sdsCalendar) === null || _a === void 0 ? void 0 : _a.setPageIndex(date[0], date[1]);
        }
        timeFormat12() {
            var _a, _b, _c, _d;
            return html `
            <div class="sds-time-picker-wrapper">
                <sds-icon name="time" size="24"></sds-icon>
                <sds-time-picker-content
                    id="${this._sdsTimePickerContentStart}"
                    hour="${(_a = this._tempStart) === null || _a === void 0 ? void 0 : _a.time.hour}"
                    minute="${(_b = this._tempStart) === null || _b === void 0 ? void 0 : _b.time.minute}"
                    format="12"
                    @sds.date-time-content.changed="${this.handleTimeChangeStart}"
                ></sds-time-picker-content>
            </div>
            <div class="sds-time-picker-wrapper">
                <sds-icon name="time" size="24"></sds-icon>
                <sds-time-picker-content
                    id="${this._sdsTimePickerContentEnd}"
                    hour="${(_c = this._tempEnd) === null || _c === void 0 ? void 0 : _c.time.hour}"
                    minute="${(_d = this._tempEnd) === null || _d === void 0 ? void 0 : _d.time.minute}"
                    format="12"
                    @sds.date-time-content.changed="${this.handleTimeChangeEnd}"
                ></sds-time-picker-content>
            </div>
        `;
        }
        timeFormat24() {
            var _a, _b, _c, _d;
            return html `
            <div class="sds-time-picker-row">
                <sds-icon name="time" size="24"></sds-icon>
                <sds-time-picker-content
                    id="${this._sdsTimePickerContentStart}"
                    hour="${(_a = this._tempStart) === null || _a === void 0 ? void 0 : _a.time.hour}"
                    minute="${(_b = this._tempStart) === null || _b === void 0 ? void 0 : _b.time.minute}"
                    format="24"
                    @sds.date-time-content.changed="${this.handleTimeChangeStart}"
                ></sds-time-picker-content>
                <div class="sds-time-picker-row__separator">-</div>
                <sds-time-picker-content
                    id="${this._sdsTimePickerContentEnd}"
                    hour="${(_c = this._tempEnd) === null || _c === void 0 ? void 0 : _c.time.hour}"
                    minute="${(_d = this._tempEnd) === null || _d === void 0 ? void 0 : _d.time.minute}"
                    format="24"
                    @sds.date-time-content.changed="${this.handleTimeChangeEnd}"
                ></sds-time-picker-content>
            </div>
        `;
        }
        selectRange(dateStart, dateEnd) {
            if (!this.sdsCalendar) {
                return;
            }
            this.sdsCalendar.setYearStateMapper(yearRangeMapper(dateStart ? dateStart[0] : undefined, dateEnd ? dateEnd[0] : undefined));
            this.sdsCalendar.setMonthStateMapper(monthRangeMapper(localeDateToLocaleMonth(dateStart), localeDateToLocaleMonth(dateEnd)));
            this.sdsCalendar.setDateStateMapper(dateRangeMapper(dateStart, dateEnd));
        }
        updateInput() {
            this._inputDate.value = this.getTimePickerValue();
        }
        dispatch(value) {
            this.dispatchEvent(new CustomEvent(SdsDateTimeRange.CHANGE_EVENT, {
                detail: { value },
                bubbles: false,
                composed: false,
            }));
        }
        getTimePickerValue() {
            if (this.start && this.end) {
                const is12 = this.format === 12;
                return `${displayDateTime(this.start, this.locale, is12)} - ${displayDateTime(this.end, this.locale, is12)}`;
            }
            return '';
        }
    };
    _SdsDateTimeRange_hint_accessor_storage = new WeakMap();
    _SdsDateTimeRange_disabled_accessor_storage = new WeakMap();
    _SdsDateTimeRange_invalid_accessor_storage = new WeakMap();
    _SdsDateTimeRange_errorMessage_accessor_storage = new WeakMap();
    _SdsDateTimeRange_placeholder_accessor_storage = new WeakMap();
    _SdsDateTimeRange_locale_accessor_storage = new WeakMap();
    _SdsDateTimeRange_format_accessor_storage = new WeakMap();
    _SdsDateTimeRange__inputDate_accessor_storage = new WeakMap();
    _SdsDateTimeRange__contextMenu_accessor_storage = new WeakMap();
    _SdsDateTimeRange__tempStart_accessor_storage = new WeakMap();
    _SdsDateTimeRange__tempEnd_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsDateTimeRange");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _hint_decorators = [property({ type: String })];
        _disabled_decorators = [property({ type: Boolean })];
        _invalid_decorators = [property({ type: Boolean })];
        _errorMessage_decorators = [property({ type: String, attribute: 'error-message' })];
        _placeholder_decorators = [property({ type: String })];
        _locale_decorators = [property({ type: String })];
        _format_decorators = [property({ type: Number })];
        __inputDate_decorators = [query('sds-input-date')];
        __contextMenu_decorators = [query('sds-context-menu')];
        __tempStart_decorators = [state()];
        __tempEnd_decorators = [state()];
        _set_start_decorators = [property({ type: String, reflect: true })];
        _set_end_decorators = [property({ type: String, reflect: true })];
        __esDecorate(_classThis, null, _hint_decorators, { kind: "accessor", name: "hint", static: false, private: false, access: { has: obj => "hint" in obj, get: obj => obj.hint, set: (obj, value) => { obj.hint = value; } }, metadata: _metadata }, _hint_initializers, _hint_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _invalid_decorators, { kind: "accessor", name: "invalid", static: false, private: false, access: { has: obj => "invalid" in obj, get: obj => obj.invalid, set: (obj, value) => { obj.invalid = value; } }, metadata: _metadata }, _invalid_initializers, _invalid_extraInitializers);
        __esDecorate(_classThis, null, _errorMessage_decorators, { kind: "accessor", name: "errorMessage", static: false, private: false, access: { has: obj => "errorMessage" in obj, get: obj => obj.errorMessage, set: (obj, value) => { obj.errorMessage = value; } }, metadata: _metadata }, _errorMessage_initializers, _errorMessage_extraInitializers);
        __esDecorate(_classThis, null, _placeholder_decorators, { kind: "accessor", name: "placeholder", static: false, private: false, access: { has: obj => "placeholder" in obj, get: obj => obj.placeholder, set: (obj, value) => { obj.placeholder = value; } }, metadata: _metadata }, _placeholder_initializers, _placeholder_extraInitializers);
        __esDecorate(_classThis, null, _locale_decorators, { kind: "accessor", name: "locale", static: false, private: false, access: { has: obj => "locale" in obj, get: obj => obj.locale, set: (obj, value) => { obj.locale = value; } }, metadata: _metadata }, _locale_initializers, _locale_extraInitializers);
        __esDecorate(_classThis, null, _format_decorators, { kind: "accessor", name: "format", static: false, private: false, access: { has: obj => "format" in obj, get: obj => obj.format, set: (obj, value) => { obj.format = value; } }, metadata: _metadata }, _format_initializers, _format_extraInitializers);
        __esDecorate(_classThis, null, __inputDate_decorators, { kind: "accessor", name: "_inputDate", static: false, private: false, access: { has: obj => "_inputDate" in obj, get: obj => obj._inputDate, set: (obj, value) => { obj._inputDate = value; } }, metadata: _metadata }, __inputDate_initializers, __inputDate_extraInitializers);
        __esDecorate(_classThis, null, __contextMenu_decorators, { kind: "accessor", name: "_contextMenu", static: false, private: false, access: { has: obj => "_contextMenu" in obj, get: obj => obj._contextMenu, set: (obj, value) => { obj._contextMenu = value; } }, metadata: _metadata }, __contextMenu_initializers, __contextMenu_extraInitializers);
        __esDecorate(_classThis, null, __tempStart_decorators, { kind: "accessor", name: "_tempStart", static: false, private: false, access: { has: obj => "_tempStart" in obj, get: obj => obj._tempStart, set: (obj, value) => { obj._tempStart = value; } }, metadata: _metadata }, __tempStart_initializers, __tempStart_extraInitializers);
        __esDecorate(_classThis, null, __tempEnd_decorators, { kind: "accessor", name: "_tempEnd", static: false, private: false, access: { has: obj => "_tempEnd" in obj, get: obj => obj._tempEnd, set: (obj, value) => { obj._tempEnd = value; } }, metadata: _metadata }, __tempEnd_initializers, __tempEnd_extraInitializers);
        __esDecorate(_classThis, null, _set_start_decorators, { kind: "setter", name: "start", static: false, private: false, access: { has: obj => "start" in obj, set: (obj, value) => { obj.start = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(_classThis, null, _set_end_decorators, { kind: "setter", name: "end", static: false, private: false, access: { has: obj => "end" in obj, set: (obj, value) => { obj.end = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsDateTimeRange = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.CHANGE_EVENT = 'sds.date-time-range.changed';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsDateTimeRange = _classThis;
})();
export { SdsDateTimeRange };
